import React from 'react';

import { IProps } from './types'

export const Container: React.FC<IProps> = ({ children }) => {
    return (
        <div className="w-full pb-6 pt-8">
            {children}
        </div>)
}